// src/views/activity/illustrations/SunflowerEmpty.jsx
// Phase 47 — Sunflower lifted from src/onboarding/OnboardingTaskReveal.jsx:103-130.
// Single source of truth shared between the onboarding "task reveal" page
// and the Activity view all-done empty state (R-11). The petal keyframe
// lives in illustrations.css (migrated from src/App.jsx); the
// .onb-sun-petal class name is preserved verbatim so the onboarding.css
// reduced-motion rule continues to apply unchanged.
//
// Calls useAnimationGate() and applies data-anim-paused on its root
// wrapper — gate composition rules in illustrations.css halt the petal
// animation when the user toggle is off / reduced-motion is set.
//
// Caller owns positioning (the onboarding wraps this in an
// absolute-positioned div; the Activity view centres it in a flex
// container).
//
// Props:
//   fadeIn?: boolean (default true) — applies opacity transition;
//     onboarding uses this for the timed reveal. The Activity view
//     passes the default.

import { useAnimationGate } from '../../../lib/useAnimationGate.js';

export default function SunflowerEmpty({ fadeIn = true }) {
  const [ref, pauseReason] = useAnimationGate();
  return (
    <div
      ref={ref}
      className="sunflower-empty"
      data-anim-paused={pauseReason || undefined}
      aria-hidden="true"
    >
      <svg viewBox="0 0 180 240" width="150" height="200" style={{ maxWidth: "100%", height: "auto", opacity: fadeIn ? 1 : 0, transition: "opacity 600ms ease" }}>
        {/* ground line */}
        <line x1="20" y1="225" x2="160" y2="225" stroke="var(--c-border)" strokeWidth="1"/>
        {/* stem */}
        <path d="M 90 225 Q 88 180 92 140 Q 95 110 90 85" stroke="#5a7a4a" strokeWidth="3" fill="none" strokeLinecap="round"/>
        {/* leaves */}
        <path d="M 90 170 Q 65 155 55 170 Q 65 180 90 175 Z" fill="#6b8a55"/>
        <path d="M 92 150 Q 120 135 132 152 Q 120 162 92 156 Z" fill="#5a7a4a"/>
        {/* petals — drawn at their final positions; animation scales them
            from the disc centre (90, 85) outward, all at once */}
        <ellipse className="onb-sun-petal" cx="90"  cy="55"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="108" cy="60"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="120" cy="75"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="122" cy="95"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="115" cy="112" rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="100" cy="120" rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="80"  cy="120" rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="65"  cy="112" rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="58"  cy="95"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="60"  cy="75"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="72"  cy="60"  rx="8" ry="18" fill="#e8a547"/>
        <ellipse className="onb-sun-petal" cx="85"  cy="55"  rx="8" ry="18" fill="#e8a547"/>
        {/* disc — the anchor from which petals open; always visible */}
        <circle cx="90" cy="85" r="18" fill="#6b4a2b"/>
        <circle cx="90" cy="85" r="14" fill="#8b5f33"/>
      </svg>
    </div>
  );
}
